import { render, staticRenderFns } from "./images-folder.vue?vue&type=template&id=4242bb78&scoped=true"
import script from "./images-folder.vue?vue&type=script&lang=js"
export * from "./images-folder.vue?vue&type=script&lang=js"
import style0 from "./images-folder.vue?vue&type=style&index=0&id=4242bb78&prod&lang=css"
import style1 from "./images-folder.vue?vue&type=style&index=1&id=4242bb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4242bb78",
  null
  
)

export default component.exports